<script setup lang="ts">
import { computed } from 'vue'

import BaseSelect, { type SelectOption } from '@/components/ui/BaseSelect.vue'
import { toursTrackType } from '@/masterdata/tours_tracktype'

interface Props {
  modelValue?: string
  disabled?: boolean
  label?: string
  placeholder?: string
  minimal?: boolean
  minimalTextClass?: string
}

withDefaults(defineProps<Props>(), {
  modelValue: undefined,
  disabled: false,
  label: 'Activity Type',
  placeholder: 'Select activity type...',
  minimal: false,
  minimalTextClass: 'text-gray-600',
})

const emit = defineEmits<{
  (e: 'update:modelValue', value: string | undefined): void
}>()

const options = computed<SelectOption[]>(() => {
  const opts: SelectOption[] = []

  Object.entries(toursTrackType).forEach(([categoryName, categoryTypes]) => {
    Object.values(categoryTypes).forEach((type) => {
      opts.push({
        id: type.garmin_id,
        name: type.name,
        group: categoryName,
      })
    })
  })

  return opts
})

const handleUpdate = (value: string | number | (string | number)[] | undefined) => {
  // Since we only support single selection and IDs are strings (garmin_id's), we can safely cast here
  emit('update:modelValue', value as string | undefined)
}
</script>

<template>
  <BaseSelect
    :model-value="modelValue"
    :options="options"
    :disabled="disabled"
    :label="label"
    :placeholder="placeholder"
    :multiple="false"
    :minimal="minimal"
    :minimal-text-class="minimalTextClass"
    searchable
    @update:model-value="handleUpdate"
  />
</template>
